export const REACTIONS = ['👍', '❤️', '🔥', '😮', '👏'];

export const STORAGE_KEYS = {
  TOKEN: 'na_access_token',
  USER: 'na_auth_user',
  PUSH_ENABLED: 'na_push_enabled',
  PUSH_PROMPT_SEEN: 'na_push_prompt_seen',
  PUSH_PROMPT_AFTER_LOGIN: 'na_push_prompt_after_login',
  PWA_INSTALL_DISMISSED: 'na_pwa_install_dismissed',
  IOS_PWA_SETUP_SEEN: 'na_ios_pwa_setup_seen',
};

export const ADMIN_TABS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'content', label: 'Content' },
  { id: 'alerts', label: 'Alerts' },
];

export const ARTICLE_FILTERS = [
  'all',
  'draft',
  'pending',
  'approved',
  'rejected',
  'published',
];

export const ARTICLE_CATEGORIES = ['general', 'news', 'culture', 'sports'];

export const NOTIFICATION_KINDS = [
  'all',
  'standard',
  'banner',
  'audio',
  'video',
  'actionable',
];
